<template>
  <div class="end">
    <h3 class="title">— 恭喜過關 —</h3>
    <h2 class="h1 mt-3" v-if="sec && sec>0">你花了 {{ sec }} 秒完成關卡</h2>
    <p class="mt-3 text-center">
      如果你喜歡我們的小遊戲，歡迎點擊下方連結提供意見回饋，以提升遊戲品質
    </p>
    <a href="https://forms.gle/ogzpetD3RoKF63Zu8" class="btn btn-warning mt-5" target="_blank">意見回饋</a>
  </div>
</template>

<script>
export default {
  name: 'simple_end',
  data() {
    return {
      sec: '',
    };
  },
  methods: {
    getSec() {
      const startTime = localStorage.getItem('startTime');
      const endTime = localStorage.getItem('endTime');
      this.sec = parseInt(new Date(endTime) - new Date(startTime), 10) / 1000;
    },
  },
  created() {
    const vm = this;
    vm.getSec();
    const endTime = localStorage.getItem('endTime');
    if (endTime === '' || endTime < 0) {
      vm.$router.push('/');
    }
  },
};
</script>

<style lang="scss" scoped>
  .end{
    height: 100vh;
    background-color: #00251A;
    background-image: url('../../assets/img/flex-bg-complete.svg');
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    *{
      color: #00251A;
      font-weight: bold;
    }
    h3 {
      font-size: 64px;
    }
    h4 {
      font-size: 36px;
      margin-top: 40px;
    }
    .title{
      margin-top: 135px;
      font-size: 48px;
    }
  }
</style>
